(function () {
    var formApp = angular.module('formApp');
    formApp.controller('complaintsHistoryController', ['$scope', '$http', 'DataServices', 'Constants', function ($scope, $http, DataServices, Constants) {

        //Fetch Edit History
        var getFeedbackEditHistory = function () {
            DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.EditHistory)
                .then(function (response) {
                    $scope.feedbackEditHistory = response.data.result;
                });
        };

        //Fetch Follow History
        var getFeedbackFollowupHistory = function () {
            DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.EditFollowup)
                .then(function (response) {
                    $scope.feedbackFollowupHistory = response.data.result;
                });
        };

        var getAssignmentHistory = function () {
            return DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.Assignment)
                .then(function (response) {
                    $scope.assignmentHistory = response.data.result;
                });
        };

        var getRecategorisationHistory = function () {
            return DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.Recategorisation)
                .then(function (response) {
                    $scope.recategorisationHistory = response.data.result;
                });
        };

        var getExternalOversightDueDateHistory = function () {
            return DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.ExternalOversightDueDate)
                .then(function (response) {
                    $scope.externalOversightDueDateHistory = response.data.result;
                });
        };

        var getRevisedDueDateHistory = function () {
            return DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.RevisedDueDate)
                .then(function (response) {
                    $scope.revisedDueDateHistory = response.data.result;
                });
        };

        var getLinkingHistory = function () {
            DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.LinkingUnLinking)
                .then(function (response) {
                    $scope.linkingHistory = response.data.result;
                });
        };

        var getOverdueHistory = function () {
            DataServices.getFeedbackHistory(Constants.RetrieveHistoryType.OverdueNotification)
                .then(function (response) {
                    $scope.overdueHistory = response.data.result;
                });
        };

        $scope.initComplainHistory = function () {
            getFeedbackEditHistory();
            getFeedbackFollowupHistory();
            getAssignmentHistory();
            getRecategorisationHistory();
            getExternalOversightDueDateHistory();
            getRevisedDueDateHistory();
            getLinkingHistory();
            getOverdueHistory();
        }
    }]);
}());